import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { GET_STYLISTS_FAILURE, GET_STYLISTS_REQUEST, GET_STYLISTS_SUCCESS } from 'onboarding/stylists/actions';

const fetchStylistsBySalon = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    config: {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    endpoint: `salon/${salonId}/stylist/`,
    types: [GET_STYLISTS_REQUEST, GET_STYLISTS_SUCCESS, GET_STYLISTS_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default fetchStylistsBySalon;
